$(document).ready(function(){
  const swiper = new Swiper('.user__section', {
    slidesPerView: 1,
    spaceBetween: 0,
    mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    navigation: {
      nextEl: '#user-section-button-next',
      prevEl: '#user-section-button-prev',
    },
  });

  $(document).on('click','.share_event_btn',function(){
    event.preventDefault();
    const url = window.location.href.split('#')[0] + "#event-block";
    const text = "Check out this event!";
    
    if (navigator.share) {
      // Use native share feature (Mobile & Modern Browsers)
      navigator.share({
        title: "Event Invitation",
        text: text,
        url: url
      }).catch(err => console.log("Share failed:", err));
    } else {
      // Copy to clipboard for older browsers
      navigator.clipboard.writeText(url).then(() => {
        alert("Event link copied! Share it with your friends.");
      });
    }
  });

  const eventTitle = $('.event_text .text').html();
  const eventDate = $('#google-calendar-link').data('event_date'); // Adjust time as needed
  const eventLocation = store_location;
  const eventDescription = $('.event_text .desc .metafield-rich_text_field').html();
  
  // Detect if the user is on Microsoft Edge
  const isEdge = navigator.userAgent.includes("Edg");
  
  // Generate Google Calendar Link (default)
  let calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventTitle)}&dates=${eventDate.replace(/[-:]/g, "")}/${eventDate.replace(/[-:]/g, "")}&details=${encodeURIComponent(eventDescription)}&location=${encodeURIComponent(eventLocation)}&sf=true&output=xml`;
  
  // If Edge, use Outlook Calendar
  if (isEdge) {
      calendarUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${eventDate}&enddt=${eventDate}&subject=${encodeURIComponent(eventTitle)}&location=${encodeURIComponent(eventLocation)}&body=${encodeURIComponent(eventDescription)}`;
  }
  document.getElementById("google-calendar-link").href = calendarUrl;
  
  // Generate ICS File for Outlook/Apple Calendar
  const icsContent = `BEGIN:VCALENDAR
  VERSION:2.0
  BEGIN:VEVENT
  DTSTART:${eventDate.replace(/[-:]/g, "")}
  SUMMARY:${eventTitle}
  LOCATION:${eventLocation}
  DESCRIPTION:${eventDescription}
  END:VEVENT
  END:VCALENDAR`;
})
async function getCoordinates(address) {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${map_api_key}`;
  const response = await fetch(url);
  const data = await response.json();
  return data.features[0].center; // [lng, lat]
}

